import { Pass, Seq, Cont, Dep, setObjectValue } from "../../framework/Processes";
import { Lambda, Var, External } from "../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../framework/comp/Types";

let RunMinigameProcess;
import("./RunMinigameProcess").then(val => { RunMinigameProcess = val.default }).catch(val => console.error(val));

function CompositeMinigameProcess(minigame, nextProcess = Pass) {
	const { name, components, score = (n) => n, onStart } = minigame;
	//TODO: make these functions context-independent
	function openSubhistoryFunc(state) {
		const historyRecord = {
			minigame,
			result: 'open subhistory',
			completed: false,
		};
		return setObjectValue("history", historyRecord, [state.objects.history.length]);
	}
	const openSubhistory = Dep(External(openSubhistoryFunc, "Function", FunctionType("Object", "Process")));
	function closeSubhistoryFunc(state) {
		const history = [ ...state.objects.history ];
		const index = history.map(({ minigame: { name } }) => name).lastIndexOf(name);
		const history0 = history.slice(0, index);
		const subhistory = history.slice(index + 1);
		const totalScore = subhistory.map(({ score }) => score).reduce((a, b) => a + b, 0);
		return setObjectValue("history", [...history0, { minigame, result: subhistory, completed: true, score: score(totalScore, state, subhistory) }]);
	}
	const closeSubhistory = Dep(External(closeSubhistoryFunc, "Function", FunctionType("Object", "Process")));
	return Seq([
		Cont("Player", { type: "AutoFinish", messages: { onStart } }, Lambda(Var("Object"), External(Pass, "Process"))),
		openSubhistory,
		RunMinigameProcess(components),
		closeSubhistory,
		nextProcess,
	]);
}

export default CompositeMinigameProcess;